// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3nwkj","label":"Completed_label__17vyL"};